export default __webpack_public_path__ + "static/media/sp-underline.77686e45.svg";